module.exports = __webpack_public_path__ + "static/media/headerImage.91ed9971.jpg";